export type RenderedTableRowSource = {
  backendRows: unknown[]
  registryRows: unknown[]
  backendEmptyFlag?: boolean
  registryEmptyFlag?: boolean
  preferRegistryFirst?: boolean
}

/**
 * Which rows an EdiTable paints.
 * empty:true with no backend rows clears a stale registry.
 * empty:false with rows uses the backend.
 * empty:false that did not yield rows falls through: the registry may still
 * hold the table (showHeader=false otherwise looks like the table vanished).
 */
export function resolveRenderedTableRows(source: RenderedTableRowSource): unknown[] {
  const {
    backendRows,
    registryRows,
    backendEmptyFlag,
    registryEmptyFlag,
    preferRegistryFirst,
  } = source

  if (backendRows.length > 0 && (backendEmptyFlag === true || backendEmptyFlag === false)) {
    return backendRows
  }
  if (backendEmptyFlag === true) {
    return []
  }
  if (registryEmptyFlag === true && registryRows.length === 0 && backendRows.length > 0) {
    return backendRows
  }
  if (registryEmptyFlag === true || registryEmptyFlag === false) {
    return registryRows
  }
  if (preferRegistryFirst && registryRows.length > 0) {
    return registryRows
  }
  if (backendRows.length > 0) {
    return backendRows
  }
  if (registryRows.length > 0) {
    return registryRows
  }
  return []
}
